module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/core-js/library/modules/_add-to-unscopables.js
// module id = 621
// module chunks = 0